import * as _ from 'underscore';
import {Location} from '@angular/common';
import {Component, OnInit, AfterViewInit} from '@angular/core';
import {IOption} from 'ng-select';
import {Router, ActivatedRoute} from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {DataService} from '../../shared/data.service';
import {FormDataService} from '../../shared/form-data.service';
import {RightSideService} from '../../shared/right-side.service';
import {NavigationBarService} from '../../shared/navigation-bar.service';
import {PageContent} from '../../shared/classes/page-content.model';
import {Category} from '../../shared/classes/category.model';
import {mapsTurkishCharToEnglishChar} from '../../../../app.component';
import {storageFactory} from '../../../../app-storage';
import hbusApiClient from '../../../../analytics/hbusApiClient';

@Component({
  selector: 'app-zeroth-tab',
  templateUrl: './zeroth-tab.component.html',
  styleUrls: ['./zeroth-tab.component.css', '../second-tab/second-tab.component.css'],
  host: {
    class: 'col-12',
  },
})
export class ZerothTabComponent implements OnInit, AfterViewInit {
  tabSelected = 0;
  errorTexts: string[] = [];
  category: Category;
  brandId: number;
  pageContent: PageContent;
  categoryId: number;
  brands: Array<IOption> = [];
  models: Array<IOption> = [];
  twinModels: Array<IOption> = [];
  zerothForm: FormGroup;
  isRedirected = false;
  isIOS: boolean;
  isAuth: boolean;
  shopperId: string;

  constructor(
    private location: Location,
    private selectBoxService: DataService,
    private formDataService: FormDataService,
    public rightSideService: RightSideService,
    private navBarService: NavigationBarService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
    this.rightSideService.isResultViewed = false;

    this.zerothForm = new FormGroup({
      paymentMethod: new FormControl('coupon', Validators.required),
    });

    this.isAuth = this.rightSideService.getIsAuth();
    this.shopperId = this.rightSideService.getShopperId();

    const redirectedCategoryId = JSON.parse(storageFactory(localStorage).getItem('redirectedCategoryId'));

    if (redirectedCategoryId) {
      this.isRedirected = true;
      this.rightSideService.setSelectedCategoryId(redirectedCategoryId);
      storageFactory(localStorage).removeItem('redirectedCategoryId');
      this.getCategory();
      this.getPageContents();
    } else {
      this.getDefaultCategory().then((id) => {
        this.route.params.subscribe(params => {
          if (params['categoryName']) {
            const categoryName = params['categoryName'];
            if (categoryName) {
              this.getCategoryUrls(categoryName);
            }
          } else {
            this.getCategory(id);
            this.getPageContents();
          }
        });
      }, error => {
        error.errorMessages.forEach(err => {
          this.errorTexts.push(err);
        });
      });
    }

    this.rightSideService.pageContentChange.subscribe(val => {
      this.pageContent = this.rightSideService.getPageContent();
    });
  }

  ngOnInit() {
    if (this.isRedirected) {
      return false;
    }

    const lastValues = this.formDataService.getZerothTabData();
    if (lastValues) {
      this.zerothForm.controls['paymentMethod'].patchValue(lastValues.paymentMethod);
    }

    this.formDataService.clear();
  }

  resetRightSide() {
    this.rightSideService.setLabel('');
    this.rightSideService.setTopImageUrl(this.category.topImageUrl);
    this.rightSideService.setImageUrl(this.category.imageUrl);
    this.rightSideService.setResetChanged(true);
  }

  ngAfterViewInit() {

  }

  getCategoryUrls(categoryName) {
    this.selectBoxService.getCategoryUrls().subscribe((res: any[]) => {
      const category = res.find(cat => cat.friendlyUrl === categoryName);
      if (category) {
        this.rightSideService.setSelectedCategoryId(category.categoryId);
        this.getCategory(category.categoryId, true);
        this.getPageContents();
        this.location.go(category.friendlyUrl);
      } else {
        this.rightSideService.selectedCategoryId = parseInt(storageFactory(localStorage).getItem('category'));
        this.getCategory(this.rightSideService.selectedCategoryId);
        this.getPageContents();
      }
    }, error => {
      error.errorMessages.forEach(err => {
        this.errorTexts.push(err);
      });
    });
  }

  getPageContents() {
    this.selectBoxService.getPageContents(this.rightSideService.getSelectedCategoryId()).subscribe((res: PageContent) => {
      this.pageContent = this.rightSideService.createPageContent(res);
      this.rightSideService.setPageContent(this.pageContent);
    }, error => {
      error.errorMessages.forEach(err => {
        this.errorTexts.push(err);
      });
    });
  }

  getDefaultCategory(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.selectBoxService.getDefaultCategory().subscribe((res: Category) => {
        this.rightSideService.selectedCategoryId = res.id;
        resolve(this.rightSideService.selectedCategoryId);
      }, error => {
        error.errorMessages.forEach(err => {
          this.errorTexts.push(err);
        });
      });
    });
  }

  getCategory(categoryId?: number, isFinded?: boolean) {
    this.zerothForm.controls['paymentMethod'].patchValue('coupon');
    if (categoryId) {
      this.rightSideService.setSelectedCategoryId(categoryId);
    }

    this.selectBoxService.getCategory(this.rightSideService.getSelectedCategoryId()).subscribe((res: Category) => {
      this.category = res;
      this.rightSideService.setCashbackEnabled(res.isCashbackEnabled);
      this.resetRightSide();

      if (!this.rightSideService.isForwarded) {
        this.rightSideService.setCategoryName(res.name);
        this.rightSideService.setImageUrl(res.imageUrl);
        this.rightSideService.setTopImageUrl(res.topImageUrl);
        this.rightSideService.setDeci(res.deci);
      }

      if (!isFinded) {
        this.location.go(mapsTurkishCharToEnglishChar(res.name).split(' ').join('-'));
      }

      const formData = {
        zeroth: this.formDataService.getZerothTabData(),
        first: this.formDataService.getFirstTabData(),
        second: this.formDataService.getSecondTab(),
      };

      if (res.isCashbackEnabled) {
        if (!_.isEmpty(formData.zeroth) && !_.isEmpty(formData.first) && !_.isEmpty(formData.second)) {
          if (!this.rightSideService.getShopperId()) {
            this.rightSideService.shopperIdChange.subscribe((val) => {
              this.redirectContactPage();
            });
          } else {
            this.redirectContactPage();
          }

          return false;
        }
        this.navBarService.setSelectedTab(0);
      } else {
        this.navBarService.setSelectedTab(1);
        this.router.navigate(['/model-secimi']);
      }
    }, error => {
      error.errorMessages.forEach(err => {
        this.errorTexts.push(err);
      });
    });
  }

  redirectContactPage() {
    const formData = JSON.parse(storageFactory(localStorage).getItem('formData'));
    if (formData.sidebar) {
      this.rightSideService.setPrice(formData.sidebar.price);
      this.rightSideService.setLabel(formData.sidebar.label);
      this.rightSideService.setImageUrl(formData.sidebar.imageUrl);
    }
    storageFactory(localStorage).removeItem('formData');
    this.navBarService.setSelectedTab(3);
    this.rightSideService.setIsRedirected(false);
    this.router.navigate(['/iletisim-bilgileri']);
  }

  clickNext() {
    if (this.zerothForm.controls.paymentMethod.value === 'cash') {
      this.rightSideService.setCashbackSelected(true);
    } else {
      this.rightSideService.setCashbackSelected(false);
    }
    this.sendDavinciEvent('sonrakiAdım');
    this.formDataService.setZerothTabData(this.zerothForm.value);
    this.navBarService.setSelectedTab(this.tabSelected + 1);
    this.router.navigate(['/model-secimi']);
  }

  sendDavinciEvent(buttonName) {
    try {
      hbusApiClient.sendEventRequest('PaymentFinalDecision', {
        page_type: 'static',
        page_value: 'eskiyi-getir-yeniyi-gotur',
        paymentOptions: this.zerothForm.controls.paymentMethod.value,
        stepNo: 1,
        stepName: 'PaymentFinalDecision',
        buyBackCategory: this.category ? this.category.name : '',
        clickButtonInfo: buttonName,
      });
    } catch (e) {
      console.error('error send event', e.message);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/tabs/zeroth-tab/zeroth-tab.component.ts